<div class="ds-notification-warning" *ngIf="!hasFrontPage && pages?.length && website?.id !== Config?.demoDomainId">
  <div>
    <i class="db-icon db-icon-ds-info-bg"></i>
    <p>
      <b>Frontpage is not set. </b>
      <span>Please publish a page to set it as frontpage.</span>
    </p>
  </div>
</div>
<db-ai-builder-demo-banner *ngIf="demoUser" [title]="'AI Builder'" [features]="features"
                           [class]="'with_margins'">
</db-ai-builder-demo-banner>
<ds-tabs class="db-ai-builder-pages__tabs" [ngClass]="{'disabled-with-overlay': demoUser, 'db-with-notice': !hasFrontPage && pages?.length}" [activeTabId]="activeTab" [beforeContent]="manageActionsRef"
         (onActiveTabChange)="setActiveTab($event.tabId)">

  <ds-tab-head *ngFor="let tab of tabs" [tabId]="tab?.id" [activeTabId]="activeTab">
    <span class="ds-account__sidebar-link" [innerHTML]="tab.label"></span>
  </ds-tab-head>
  <ds-tab-content [tabId]="activeTab" [activeTabId]="activeTab">
    <db-ai-builder-pages-table [websiteId]="website?.id" [websiteHomeUrl]="demoUser ? Config?.demoWebsiteUrl : website.site_url"
                               [websiteAdminUrl]="website?.adminUrl"
                               [websiteHosted]="!!website.domain_hash" [adminElementorUrl]="website?.adminElementorUrl"
                               [heads]="activeTab === 'pages' ? heads : (activeTab === 'slide' ? templateSlidesHeads : templateHeads)"
                               [showCreatedWithAiBtn]="activeTab === 'pages'"
                               [activeTab]="activeTab"
                               [searchVal]="searchTerm.value"
                               [currentUserSubscription]="userSubscription" [demoUser]="demoUser">
    </db-ai-builder-pages-table>
  </ds-tab-content>
</ds-tabs>

<ng-template #manageActionsRef>
  <p *ngIf="onlyTrials && aiBuilderCreatedPages?.length">Added pages {{ aiBuilderCreatedPages?.length }} of {{pagesLimit}}</p>
  <div class="db-ai-builder-pages__mange-actions">
    <div *ngIf="!isMobile">
      <ds-search-input class="db-ai-builder-pages__mange-actions-search" [formControl]="searchTerm"
                       [placeholder]="'text_searchEllipsis' | dbText" [hasSearchIcon]="true"></ds-search-input>
    </div>
    <div class="db-edit-button-wrap" [ngClass]="{'db-single': !userSubscription?.plan?.services?.ai_builder || !hasFrontPage}">
      <ng-container *ngIf="hasFrontPage">
        <a class="ds-btn rectangle" [ngClass]="{'ds-btn-medium': isMobile}"
           *ngIf="paidClient && !isMobile"
           dbWpLink [adminLink]="website?.adminUrl + '?edit.php?post_type=page&from=tenweb_dashboard&open=homepage'"
           [websiteId]="website?.id" target="_blank" rel="noopener">
          <span>Edit Website</span>
        </a>
        <a class="ds-btn rectangle" [ngClass]="{'ds-btn-disabled': (createdPagesLoading$ | async) || disableAddPage, 'ds-btn-medium': isMobile}" *ngIf="!paidClient && !isMobile"
           (click)="showCheckoutUpgradeDialog(null, null)">
          <span>Edit Website</span>
        </a>
      </ng-container>
      <a class="ds-btn-outline-blue mr20"
              [ngClass]="{'ds-btn-disabled': disableAddPage, 'ds-btn-medium': isMobile, 'db-demo': demoUser}" *ngIf="!!demoUser"
             (click)="openIframe(previewUrl)" target="_blank">
        <span>Preview Website</span>
      </a>
      <button class="ds-btn-blue"
          [dsTooltip]="'Add new page'" dsTooltipColor="black" dsTooltipSize="small" dsTooltipAlign="left"
          [ngClass]="{'ds-btn-disabled': disableAddPage, 'ds-btn-medium': isMobile, 'db-demo': demoUser}" (click)="onlyTrials
           && aiBuilderCreatedPages?.length >= pagesLimit ? showCheckoutInfoDialog() : addPage(false, false)">
        <span><i class="db-icon db-icon-ds-add"></i>{{'text_ai-builder.add-page' | dbText}}</span>
      </button>
      <a class="ds-link" [ngClass]="{'ds-disabled': (createdPagesLoading$ | async) || disableAddPage} " *ngIf="!isMobile && userSubscription?.plan?.services?.ai_builder && !!website?.domain_hash"
              (click)="handleClick()">
        <img src="assets/images/icons/ai-generate.svg">
        <span>Generate with AI</span>
      </a>
      <button class="ds-btn ds-btn-medium rectangle" [ngClass]="{'ds-btn-disabled': (createdPagesLoading$ | async) || disableAddPage}" *ngIf="isMobile && userSubscription?.plan?.services?.ai_builder && !!website?.domain_hash"
              (click)="handleClick()">
        <span>Generate</span>
      </button>
    </div>
  </div>
</ng-template>
